import { BaseEntity } from "@app/models/rest/base-entity";
import { SubDivision } from "@app/models/rest/roster/sub-division";
import { HateoasResource } from "@lagoshny/ngx-hateoas-client";
import { TimesheetCode } from "@app/models/rest/timesheet-code";

@HateoasResource("shifts")
export class Shift extends BaseEntity {
  public offsetDay: number;
  public startOffsetHour: number;
  public startOffsetMinute: number;
  public duration: number;
  public subDivision: SubDivision;
  public cyclicalReservationPercent: number;
  public normalReservationPercent: number;
  public highReservationPercent: number;
  public emergencyReservationPercent: number;
  public travelTimesheetCode: TimesheetCode;
  public workingTimesheetCode: TimesheetCode;
  public overrideTimesheetCode: TimesheetCode;
  public overDuration: number;
}
